import { patientApi } from '@/api/PatientApi'
import { WHITENING_SUMMARY_QUERY_KEY } from '@/api/hooks/useFetchWhiteningSummary'
import type { WhiteningOrderKind } from '@/api/types/PatientApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

/**
 * Claims the kit, or asks for more gel.
 *
 * The answer is the new order, but the screen is built from the summary — which also carries
 * whether anything else may be ordered now — so the summary is invalidated rather than written
 * into: one read decides every state, and the server stays the one deciding it.
 */
const useCreateWhiteningOrder = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ kind }: { kind: WhiteningOrderKind }) =>
			patientApi.createWhiteningOrder({ kind }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: WHITENING_SUMMARY_QUERY_KEY })
		},
	})
}

export { useCreateWhiteningOrder }
